import axios from 'axios';
import type { SetRequired } from 'type-fest';

import { NetworkError } from './types';

export function isNetworkError(error: unknown): error is SetRequired<NetworkError, 'response'> {
  return Boolean(axios.isAxiosError(error) && error.response && error.response.status && error.response.status >= 400);
}
